import { render, staticRenderFns } from "./variation.vue?vue&type=template&id=ec96fbac&"
import script from "./variation.vue?vue&type=script&lang=js&"
export * from "./variation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports